/** User-facing product name for Data 360 (UI copy only). */
export const DATA_360_DISPLAY_NAME = 'DATA 360'

/** Normalize mixed Data 360 branding in user-visible copy (e.g. API/server messages). */
export function formatData360DisplayText(text: string): string {
  return text
    .replace(/Data\s*360/gi, DATA_360_DISPLAY_NAME)
    .replace(/\bdata360\b/gi, DATA_360_DISPLAY_NAME)
}
